import React from "react";
import { Card, CardBody, FormGroup } from "reactstrap";
import { City, Address, Airport } from "../../../Constant/index";
import { Image } from "../../../AbstractElements";
import Plane from "../../../assets/images/booking/plane.png";
import Select from "react-select";
import CustomAutoSuggest from "../../../CommonElements/CustomAutoSuggest";
import CustomSelect from "../../../CommonElements/CustomSelect";
const AirportTransferComp = ({
  toggleAddress,handleToggle,setHandleToggle,
  setToggleAddress,
  cityField,
  airportCityData,
  getAddressData,
  handleDestSelectChange,
  airportField,
  handleAirportSelectChange,
  handleCustomAirportSelectChange,
  bookingType,
  register,
  setValue,
  watch
}) => {
  return (
    <Card className="address-box">
      <div
        className="reverse-icon"
        onClick={() => { 
          setToggleAddress(!toggleAddress);
          setHandleToggle(!handleToggle);
        }}
      ></div>
      <CardBody className="address-body">
        <div className={`location-timeline ${toggleAddress ? "c-to-a" : ""}`}>
          <div className="location-media">
            <div className="plane-image">
              <Image
                attrImage={{
                  alt: "",
                  src: Plane,
                }}
              />
            </div>
            {/* {!cityField.value ? (
              <div className="airport-label airport-details">{Airport}</div>
            ) : bookingType == "Book" ? (
              <div className="col-lg-11 airport-dropdown airport-details">
                <Select
                  className="service-select"
                  classNamePrefix="select"
                  isClearable={false}
                  isSearchable={false}
                  // defaultValue={}
                  value={airportCityData.find((element) => {
                    return element?.value?.id == airportField?.value?.id;
                  })}
                  onChange={handleAirportSelectChange}
                  placeholder="Select Airport"
                  options={airportCityData}
                />
              </div>
            ) : (
              <div className="col-lg-11 airport-dropdown airport-details">
                <CustomAutoSuggest
                  id={'Address pickup'}
                  handleSelectChange={handleCustomAirportSelectChange}
                  options={getAddressData}
                  placeholder={"Address"}
                  register={register}
                  registerName={"airport"}
                />
              </div>
            )} */}
            {!cityField.value ? (
              <div className="airport-label airport-details">{Airport}</div>
            ) : (
              <div className="col-lg-11 airport-dropdown airport-details">
                <CustomSelect
                  className="service-select"
                  classNamePrefix="select"
                  isClearable={false}
                  isSearchable={false}
                  // defaultValue={}
                  value={airportCityData.find((element) => {
                    return element?.value?.name == airportField?.value?.name;
                  })}
                  onChange={handleAirportSelectChange}
                  placeholder="Select Airport"
                  options={airportCityData}
                />
              </div>
            )}
          </div>
          <div className="location-media">
            <div className="circle-dot"></div>
            <div className="city-details">
              <div className="city-label">{City}</div>
              <div className="city-content">
                <FormGroup className="col-12 animate-input input-margin">
                  <CustomAutoSuggest
                    id={"Address dest"}
                    handleSelectChange={handleDestSelectChange}
                    options={getAddressData}
                    placeholder={"Address"}
                    register={register}
                    registerName={"destAddress"}
                    isClearable={true}
                    setValue={setValue}
                    watch={watch}
                    dependentRegisterName={"destAddressDropdown"}
                  />
                </FormGroup>
              </div>
            </div>
          </div>
        </div>
      </CardBody>
    </Card>
  );
};

export default AirportTransferComp;
